// Button styles
export const BUTTON_STYLES = {
  base: {
    borderRadius: 4,
    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    cursor: 'pointer'
  },
  hovered: {
    transform: 'scale(1.25)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.5), 0 0 20px rgba(255, 255, 255, 0.3)',
    filter: 'brightness(1.2) contrast(1.1)',
    zIndex: 1000
  }
};

// Drawer styles
export const DRAWER_STYLES = {
  floatingContainer: {
    position: 'fixed',
    bottom:20,
    right: 20,
    zIndex: 999,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  menuDropdown: {
    minWidth: 180,
    padding: 0
  },
  menuItem: {
    fontWeight: 500,
    fontSize: 18,
    padding: '12px 16px'
  },
  image: {
    width: '100%',
    maxWidth: 400,
    border: '1px solid #eee',
    borderRadius: 4,
    marginBottom: 8
  },
  smallImage: {
    width: 80,
    border: '1px solid #eee',
    borderRadius: 4
  },
  mediumImage: {
    width: 120,
    border: '1px solid #eee',
    borderRadius: 4
  },
  button: {
    background: 'black',
    color: 'white',
    border: 0,
    borderRadius: 4,
    padding: '8px 16px',
    fontWeight: 600,
    cursor: 'pointer'
  },
  closeButton: {
    background: '#2456a6',
    color: 'white',
    border: 0,
    borderRadius: 4,
    padding: '8px 24px',
    fontWeight: 600,
    cursor: 'pointer'
  }
};

// Help menu items
export const HELP_MENU_ITEMS = [
  {
    id: 'help',
    label: 'Help',
    url: 'https://google.com'
  },
  {
    id: 'whats-new',
    label: "What's New",
    url: 'https://google.com'
  },
  {
    id: 'live-training',
    label: 'Live Training',
    url: 'https://google.com'
  },
  {
    id: 'training-videos',
    label: 'Training Videos',
    url: 'https://google.com',
    hasHover: true
  }
];

// MFA Guides configuration
export const MFA_GUIDES = [
  {
    id: 'customer',
    title: 'Reset Customer/MyFexPay MFA',
    drawerKey: 'mfa',
    zIndexOffset: 100,
    content: {
      title: 'How to Reset Customer/MyFexPay MFA',
      steps: [
        'The Dealership User will need to go to the Accounts (folder w/dollar sign) icon from the left-hand navigation menu and then click on Search Accounts.',
        'Search for the customer and select the account.',
        'Click on the Action tab.',
        'Click on the RESET MFA button.',
        'Click on the Reset Multifactor Authentication button to the right of the name (as highlighted in red below).',
        'A blue banner will briefly display confirming it was successful.',
        'Contact the customer and ask them to login again. Explain that they will be prompted to setup their MFA once more during their next login.'
      ],
      images: [
        { src: '/src/assets/placeholder1.png', alt: 'Accounts icon', style: 'small' },
        { src: '/src/assets/placeholder2.png', alt: 'Search Accounts', style: 'medium' },
        { src: '/src/assets/placeholder3.png', alt: 'Reset MFA button', style: 'large' },
        { src: '/src/assets/placeholder4.png', alt: 'Reset Multifactor Authentication', style: 'large' }
      ],
      note: {
        title: 'NOTE:',
        content: 'If the below image displays, this means there are no MyFexPay accounts currently linked to this loan/IDMS account.',
        image: { src: '/src/assets/placeholder5.png', alt: 'No Email ID found', style: 'large' },
        helpLink: {
          text: 'CLICK ON THE LINK FOR HELP:',
          url: '#',
          label: 'How to Resolve the No Customer/MyFexPay Account'
        }
      }
    }
  },
  {
    id: 'dealership',
    title: 'Reset a Dealership User MFA',
    drawerKey: 'dealership',
    zIndexOffset: 110,
    content: {
      title: 'How to Reset a Dealership User MFA',
      steps: [
        'The Dealership Admin will need to click on Settings (the wrench icon), located on the left-hand navigation menu, then click on Users.',
        'Click on the Reset Multifactor Authentication button to the right of the name (as highlighted in red below).',
        'Click Yes on the pop-up window that displays. You will briefly see a blue banner across the top of the screen stating that the reset of MFA for this user was successful.',
        'Contact the dealership user and ask them to login again. Explain that they will be prompted to setup their MFA once more during their next login.'
      ],
      images: [
        { src: '/src/assets/placeholder6.png', alt: 'Settings icon', style: 'small' },
        { src: '/src/assets/placeholder7.png', alt: 'Users', style: 'medium' },
        { src: '/src/assets/placeholder8.png', alt: 'Reset MFA button', style: 'large' }
      ]
    }
  },
  {
    id: 'disabled',
    title: 'Reset your MFA if you\'re receiving "Your account has been disabled or setup is not complete?"',
    drawerKey: 'disabled',
    zIndexOffset: 120,
    content: {
      title: 'Reset your MFA if you\'re receiving, "Your account has been disabled or setup is not complete" message',
      description: 'Most likely, you\'re a new user and you have not completed the invitation email; therefore when you logged in, it broke the new user system flow of configuring your Multi-Factor Authentication (MFA).',
      steps: [
        'If you\'re receiving this message below, you need to complete a password reset by clicking on the Forgot your password? link highlighted in red below.',
        'Follow the steps to reset your password. You will have to re-enter your email address and enter the code sent to you.',
        'By doing so, this will bring your user profile back into the correct system flow which will prompt you to setup MFA the next time you attempt to login.'
      ],
      images: [
        { src: '/src/assets/placeholder9.png', alt: 'Forgot your password', style: 'large' }
      ]
    }
  },
  {
    id: 'lost',
    title: 'Reset your MFA if you\'ve Lost or Changed Device (phone, iPad, laptop)',
    drawerKey: 'lostDevice',
    zIndexOffset: 130,
    content: {
      title: 'Reset your MFA if you\'ve Lost or Changed your Device (phone, iPad, laptop)',
      description: 'You will need to have your Multi-Factor Authentication (MFA) reset in order to login.',
      steps: [
        'Contact the User Admin at the dealership and tell them you\'ve lost or changed your device. The Admin will reset the MFA and contact you when completed.',
        'You, the user, will set up MFA again using your new device upon your next login.'
      ],
      helpLink: {
        text: 'CLICK ON THE LINK FOR HELP:',
        url: '#',
        label: 'How to Reset a Dealership User MFA'
      },
      important: {
        title: 'IMPORTANT:',
        content: [
          'If a User Admin is not available, the user must reach out to their CSM to get their MFA reset.',
          'If you don\'t know who your CSM is, you can reach out to IDMS Support and they should be able to direct you to your CSM.'
        ]
      }
    }
  },
  {
    id: 'login',
    title: 'Resolve issues when logging in using MFA',
    drawerKey: 'loginIssue',
    zIndexOffset: 140,
    content: {
      title: 'Are you having issues logging in using MFA? (For Dealership Users)',
      description: 'If so, it\'s most likely that you entered the incorrect Multi-Factor Authentication (MFA) code as displayed in the authorization text message or authenticator app. You will need to login again and follow the steps using text messages OR using the authentication app.',
      sections: [
        {
          title: 'Text Messages:',
          content: 'If you are receiving codes via text messages, you may have to click on the Send new code button (shown below) because the last code may be expired.',
          important: 'If you receive a new code via text, it will expire the previous code even if you have not yet requested the new code yet.',
          image: { src: '/src/assets/placeholder10.png', alt: 'Send new code', style: 'large' }
        },
        {
          title: 'Authenticator App:',
          content: 'If you\'re using the authenticator app, enter the current code being displayed in the authenticator app, in the field shown below. Then, click on the Verify button.',
          image: { src: '/src/assets/placeholder11.png', alt: 'Authenticator app', style: 'large' }
        }
      ]
    }
  },
  {
    id: 'noemail',
    title: 'Resolve issues with the "No Email ID found to reset MFA" message',
    drawerKey: 'noEmail',
    zIndexOffset: 150,
    content: {
      title: 'What does this message mean? No Email ID found to reset Multi Factor Authentication.',
      description: 'If a customer receives the message (shown below) in their Action tab, it means that none of their MyFexPay accounts are linked to this loan/IDMS account.',
      image: { src: '/src/assets/placeholder5.png', alt: 'No Email ID found', style: 'large' },
      steps: [
        'Look in IDMS to see if the customer has other loan accounts. If there is another account, go to the Reset MFA window within the Action tab and confirm there\'s an email address listed.',
        'To reset their MFA, click on the Reset MFA button next to their email address, as highlighted in red below.',
        'If the customer doesn\'t have any loans that have a MyFexPay account linked to it, they will have to create a new MyFexPay account with a new email address.'
      ],
      images: [
        { src: '/src/assets/placeholder4.png', alt: 'Reset MFA button', style: 'large' }
      ]
    }
  }
]; 